import { Component, OnInit, Input } from '@angular/core';
import { VendorPaymentDetails } from '../../../../../models/VendorPaymentDetails';

@Component({
  selector: 'app-payment-details-v',
  templateUrl: './payment-details-v.component.html',
  styleUrls: ['./payment-details-v.component.scss']
})
export class PaymentDetailsVComponent implements OnInit {
  @Input() vendorPaymentDetails: VendorPaymentDetails;
  GPVID: string;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/vendor/my-vendor/payments-view/payment-details-v/payment-details-v.component.ts